// removed by extract-text-webpack-plugin
module.exports = {"DriverData":"DriverData__DriverData__2EwLr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DriverData/DriverData.css
// module id = 266
// module chunks = 1